import { render, staticRenderFns } from "./blackListCompanyDetail.vue?vue&type=template&id=5fd905df&scoped=true"
import script from "./blackListCompanyDetail.vue?vue&type=script&lang=js"
export * from "./blackListCompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./blackListCompanyDetail.vue?vue&type=style&index=0&id=5fd905df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd905df",
  null
  
)

export default component.exports